import React, { useState } from 'react'
import SwitchInput from 'lib/switch'
import { ArrowPathIcon } from '@heroicons/react/24/outline'
import Fetch from 'lib/fetch'

const ActiveToggle = ({ nodeStatus, nodeId, mutate }) => {
  const [working, setWorking] = useState(false)

  const url = `/nodes/${nodeId}/operational_state`

  const toggleActive = () => {
    const newState =
      nodeStatus?.appliedRevisionState?.operationalState === 'active'
        ? 'idle'
        : 'active'
    setWorking(true)
    Fetch(url, {
      method: 'POST',
      body: JSON.stringify({ node: { operational_state: newState } }),
    }).then((response) => {
      if (response.ok) {
        setWorking(false)
        if (mutate) {
          mutate()
        }
      } else {
        setWorking(false)

        response
          .json()
          .then((data) => alert(`Could not change state: ${data.errors}`))
      }
    })
  }

  return (
    <div>
      {working ? (
        <ArrowPathIcon className="animate-spin w-4 h-4" />
      ) : (
        <SwitchInput
          label={nodeStatus?.appliedRevisionState?.operationalState}
          checked={
            nodeStatus?.appliedRevisionState?.operationalState === 'active'
          }
          onChange={toggleActive}
        />
      )}
    </div>
  )
}

export default ActiveToggle
